module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門5_1.f397c0ab.png";